import { component } from "picoapp";

export const cartToggle = component((node: HTMLElement) => {
  const valueNode = node.querySelector<HTMLElement>(
    ".cart-item-count-badge__value"
  );

  const updateCartItems = (event: CustomEvent) => {
    const cartItemCount = event.detail?.cart?.cart?.item_count;
    if (isNaN(cartItemCount)) return false;
    const text = String(cartItemCount);
    if (valueNode) {
      valueNode.textContent = text;
    } else {
      node.textContent = text;
    }
    if (cartItemCount === 0) {
      node.style.display = "none";
    } else {
      node.style.display = "flex";
    }
  };

  document.addEventListener("rebuy:cart.change", updateCartItems);

  return () => {
    document.removeEventListener("rebuy:cart.change", updateCartItems);
  };
});
